import ClubItemBase from "./club_item_base";
import ClubMemberBase from "./club_member_base";



const {ccclass, property} = cc._decorator;

@ccclass
export default class ClubAuditItem extends ClubMemberBase {


    onAccept(){

        this.dispatchEvent("club_audit_accept");
    }

    onRefuse(){

        this.dispatchEvent("club_audit_refuse");
    }
  
}
